export const guidePagesUA = [
  './ua/page1.html',
  './ua/page2.html',
  './ua/page3.html',
  './ua/page4.html',
  './ua/page5.html',
];
